import { render, staticRenderFns } from "./EditDialog2.vue?vue&type=template&id=0911db51&scoped=true&"
import script from "./EditDialog2.vue?vue&type=script&lang=js&"
export * from "./EditDialog2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0911db51",
  null
  
)

export default component.exports